// Inspired by this blog post
// https://stanko.github.io/react-rerender-in-component-did-mount/

export function setShortTimeout(callback) {
  setTimeout(callback, 50);
}

export function startAnimation(callback) {
  // Old Firefox hack
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      callback();
    });
  });
}
